import { FunctionComponent } from 'react';
import { FormText, FormTextProps } from 'react-bootstrap';
import classNames from 'classnames';

import classes from './text-feedback.module.scss';

export const TextFeedback: FunctionComponent<FormTextProps> = ({
  className,
  ...props
}) => (
  <FormText
    className={classNames('text-muted', classes.textFeedback, className)}
    {...props}
  />
);
